import React from 'react';
import { projects } from '../data/projects';
import { ProjectCard } from './ProjectCard';
import { SectionLabel } from './SectionLabel';
export function FeaturedWork() {
  return <section id="work" className="site-container py-24 md:py-32" data-id="element-294" data-mp="3kl043wxqfgh7">
      <div className="mb-14 flex items-end justify-between gap-6 border-t border-border pt-5 md:mb-20" data-id="element-295" data-mp="3kmt814gynmli">
        <SectionLabel data-id="element-296" data-mp="3ooo9c8yw5zza">Selected work</SectionLabel>
        <p className="font-display text-sm font-medium uppercase tracking-[0.1em] text-muted" data-id="element-297" data-mp="g6iedqy0gw9x">
          2016 — Present
        </p>
      </div>

      <div className="grid grid-cols-1 gap-y-20 md:grid-cols-2 md:gap-x-10 md:gap-y-28" data-id="element-298" data-mp="l53hpz8k7w2l">
        {projects.map((project, index) => <ProjectCard key={project.slug} project={project} index={index} data-id="element-299" data-mp="bftmwbmbzzas" data-mpi={index} />)}
      </div>
    </section>;
}